"use strict";
import {on, findAllIn, closest, findIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-product-grid__form[data-tracking-filter]', function (form) {
        let mainCategory = form.getAttribute('data-tracking-main-category'),
            subCategory = form.getAttribute('data-tracking-category');

        on('change', function (evt) {
            if (window.cookieconsent && window.cookieconsent.currentConsentStatus().statistic === true) {
                window.dataLayer.push({
                    'event': 'filter',
                    'main_category' : mainCategory,
                    'sub_category' : subCategory,
                    'used_filter' : evt.target.name,
                    'filter_value' : evt.target.value
                });
            }
        }, form);

        findAllIn('.js-product-grid__submit-section-btn', form).map((submitButton) => {
           on('click', (evt) => {
               if (window.cookieconsent && window.cookieconsent.currentConsentStatus().statistic === true) {
                   let section = closest('.js-product-grid__submit-section', submitButton),
                       slider = findIn('.js-range-slider', section);

                   if (slider) {
                       window.dataLayer.push({
                           'event': 'filter',
                           'main_category' : mainCategory,
                           'sub_category' : subCategory,
                           'used_filter' : slider.getAttribute('data-input-group'),
                           'filter_value_translated' : findIn('.js-range-slider__val-display', slider).value,
                           'filter_dimension_from' : findIn('.js-range-slider__min', slider).value,
                           'filter_dimension_to' : findIn('.js-range-slider__max', slider).value
                       });
                   }
               }
           }, submitButton);
        });
    });
}